import type { ISummaryData } from "@/types/summary";
import { isInsightPresent } from "@/utils/isInsightPresent";

export function hasOverviewCards(summaryData: ISummaryData | null): boolean {
  if (!summaryData) return false;

  const hasBookDetails =
    summaryData.manuscript_word_count != null &&
    summaryData.reading_time_minutes != null;
  const hasAnyInsight =
    isInsightPresent.synopsis(summaryData.synopsis) ||
    isInsightPresent.characters(summaryData.characters) ||
    isInsightPresent.worldAndSetting(summaryData.world_setting) ||
    isInsightPresent.tropes(summaryData.tropes);

  return hasBookDetails || hasAnyInsight;
}
